angular.module('pitch.app')
    .directive('favouriteBtn', ['Favourite',
        function(Favourite) {
            "use strict";
            return {
                scope: {
                    pitch: '=',
                    track: '=',
                },
                restrict: 'EA',
                replace: false,
                link: function($scope) {
                    $scope.buttonDisabled = false;
                    $scope.spinner = false;
                    $scope.favourite = $scope.pitch.favourites.indexOf(String($scope.track.id)) >= 0;

                    $scope.addDeleteFavourite = function() {
                        $scope.buttonDisabled = true;
                        $scope.spinner = true;
                        if($scope.favourite) {
                            Favourite.deleteFavourite($scope.track.id, $scope.pitch.hash)
                                .finally(function() {
                                    $scope.buttonDisabled = false;
                                    $scope.spinner = false;
                                });
                            $scope.pitch.favourites.splice($scope.pitch.favourites.indexOf(String($scope.track.id)), 1);
                            $scope.favourite = false;
                        } else {
                            Favourite.addFavourite($scope.track.id, $scope.pitch.hash)
                                .finally(function() {
                                    $scope.buttonDisabled = false;
                                    $scope.spinner = false;
                                });
                            $scope.pitch.favourites.push(String($scope.track.id));
                            $scope.favourite = true;
                        }
                    };
                },
                template: '<button ng-disabled="buttonDisabled" ng-click="addDeleteFavourite()" role="button" class="btn btn-animate favourite-button">' +
                                '<i aria-hidden="true" ng-class="spinner ? \'icon fa fa-refresh fa-spin\' : (favourite ? \'icon fa fa-star\' : \'icon fa fa-star-o\')"></i>' +
                                '<span class="sr-only">Favourite</span>' +
                            '</button>'
            };
        }])
;


// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/favourite.js